import axios from "axios";
import { API_URL } from "../../config";
import { AUTH_TYPES } from "../reducers/authReducers";
import tools from "../../helpers/tools";
import jwt_decode from "jwt-decode";
import { PLATFORM } from "../../config";
import { ERROR_TYPES } from "../reducers/errorReducers";

export const authActions = (state, dispatch) => {
  function loginUser(userData) {
    // fetch api
    dispatch({
      type: ERROR_TYPES.CLEAR_ERRORS,
    });
    axios
      .post(API_URL + "auth/login/" + PLATFORM, userData)
      .then((res) => {
        // Save to localStorage
        const token = res.data;
        // Set token to ls
        localStorage.setItem("jwtToken", token);
        // Set token to Auth header
        tools.setAuthToken(token);
        // Set current user

        dispatch({
          type: AUTH_TYPES.SET_CURRENT_USER,
          payload: jwt_decode(token),
        });
      })
      .catch((err) => {
        tools.filterError(err, dispatch, AUTH_TYPES.LOAD_CURRENT_USER);
      });
  }

  function logoutUser() {
    // Remove token from localStorage
    localStorage.removeItem("jwtToken");
    // Remove auth header for future requests
    tools.setAuthToken(false);
    // Set current user to {} which will set isAuthenticated to false
    dispatch({ type: AUTH_TYPES.CLEAR_CURRENT_USER, payload: {} });
    //tools.filterAlert("info", "Vous avez été correctement déconnecté.");
  }

  return {
    loginUser,
    logoutUser,
  };
};
